import {
  type HistoryOptions,
  parseAsBoolean,
  parseAsString,
  useQueryStates,
} from '@vrplatform/query-params';
import { useCallback } from 'react';
import { removeDrawerStateFromUrl } from '../../utils';

type View = 'overview' | 'edit';
type OpenReviewOptions = {
  history?: HistoryOptions;
  autoAdvance?: boolean;
};

export function useOwnerDetailDrawer() {
  const [opts, set] = useQueryStates({
    owner: parseAsString,
    view: parseAsString,
    review: parseAsBoolean,
    reviewNext: parseAsBoolean,
  });

  return {
    opened: !!opts.owner,
    open: useCallback(
      (id: string, view?: 'overview' | 'edit', type?: HistoryOptions) => {
        removeDrawerStateFromUrl();
        set(
          { owner: id, view, review: null, reviewNext: null },
          {
            history: type || 'push',
          }
        );
      },
      [set]
    ),
    openReview: useCallback(
      (id: string, view?: 'overview' | 'edit', options?: OpenReviewOptions) => {
        const shouldAutoAdvance = options?.autoAdvance ?? true;

        removeDrawerStateFromUrl();
        set(
          {
            owner: id,
            view,
            review: true,
            reviewNext: shouldAutoAdvance,
          },
          {
            history: options?.history || 'push',
          }
        );
      },
      [set]
    ),
    close: useCallback(() => set(null), [set]),
    ownerId: opts.owner,
    view: (opts.view || 'overview') as View,
    setView: useCallback((view: View) => set({ view }), [set]),
    isReview: !!opts.review,
    shouldAutoAdvanceReview: !!opts.review && opts.reviewNext !== false,
  };
}
